import { render, staticRenderFns } from "./create-bi-follow-gift.vue?vue&type=template&id=b3cd9670&scoped=true"
import script from "./create-bi-follow-gift.vue?vue&type=script&lang=js"
export * from "./create-bi-follow-gift.vue?vue&type=script&lang=js"
import style0 from "./create-bi-follow-gift.vue?vue&type=style&index=0&id=b3cd9670&prod&lang=scss&scoped=true"
import style1 from "./create-bi-follow-gift.vue?vue&type=style&index=1&id=b3cd9670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cd9670",
  null
  
)

export default component.exports